import type { MappedTuple, Tuple } from "@/interfaces/estimate-detail";
import type { Estimation } from "@/interfaces/estimation.interface";
import type { ReactNode } from "react";
import { Wrench, TriangleAlert, Sparkle } from "lucide-react";
import type { Category } from "..";
import { GroupLines } from "../GroupLines";

interface TabContentProps {
  className?: string;
  selectedTab?: Category;
  lines: MappedTuple[];
  tuples: Tuple[];
  pageId: string;
  estimateId?: string;
  estimation?: Estimation;
  onDelete?: (val: string, uniqueId: string, category?: Category) => void;
  onSelectItem?: (uniqueId: string, category?: Category) => void;
}

export const TabContent = ({
  selectedTab,
  className,
  lines,
  pageId,
  tuples,
  onSelectItem,
  onDelete,
  estimation,
  estimateId,
}: TabContentProps) => {
  const tabStyle: Record<Category | string, string> = {
    issues: "!bg-yellow-50",
    recommended: "bg-blue-50",
    removeRules: "bg-purple-50",
  };

  const itemIcon: Record<Category | string, ReactNode> = {
    issues: <TriangleAlert className="h-5 w-5 text-yellow-500" />,
    recommended: <Sparkle className="h-5 w-5 text-blue-600" />,
    removeRules: <Wrench className="h-5 w-5 text-purple-600" />,
  };

  return (
    <div
      className={`transition-all duration-300 ${selectedTab && lines?.length ? "h-auto p-3" : "h-0 p-0"} ${className} ${tabStyle[selectedTab ?? ""]}`}
    >
      <GroupLines
        showConfirm
        estimateId={estimateId}
        estimation={estimation}
        selectedTab={selectedTab}
        tuples={tuples}
        className="border-0"
        lineClassName="border-b"
        onSelectItem={onSelectItem}
        onDelete={onDelete}
        itemIcon={itemIcon}
        lines={lines}
        pageId={pageId}
      />
    </div>
  );
};
